/**
 * Referral detail modal — labels and step descriptions.
 * Copy only from Figma «Referral Program» → referral status modal variants.
 * Do not paraphrase or pull from FAQ/PRD; update when design changes.
 */
export const REFERRAL_DETAIL_MODAL_COPY = {
  steps: {
    submitted: {
      label: 'Referral submitted',
      description: 'We received your referral and added it to our queue.',
    },
    contacted: {
      label: 'Contacted',
      description: 'Our team has reached out to your referral.',
    },
    inProgress: {
      label: 'In progress',
      description: "We're helping them plan their journey with BCC.",
    },
    booked: {
      label: 'Booked',
      description:
        'Their trip is booked. Your reward will be added after they complete their journey.',
    },
    journeyCompleted: {
      label: 'Journey completed',
      description: 'They completed their trip.',
    },
    success: {
      label: 'Success',
      description: "We've added your credits!",
    },
    notEligible: {
      label: 'Referral not eligible',
      description:
        "This referral doesn't meet the program's eligibility requirements, so no reward will be issued",
    },
    expired: {
      label: 'Referral expired',
      description:
        'The 3-month booking period has ended without an eligible booking, so no referral reward will be issued.',
    },
    rejected: {
      label: 'Rejected',
      description:
        "This referral didn't result in a booking with BCC, so no referral reward will be issued.",
    },
  },
} as const;
